import type { XInput } from '@playcastdotio/CoreTypes';
import clsx from 'clsx';

interface GamepadStateProps {
  prefix: string;
  gamepad: XInput;
  value: number;
}

export const ButtonStick = (props: GamepadStateProps) => {
  const { gamepad, prefix, value } = props;
  const isPressed = gamepad.wButtons & value;
  const fillColor = isPressed ? `rgba(250, 204, 21, 255)` : 'black';
  const isLeft = prefix.includes('left');

  return (
    <svg
      width='42'
      height='40'
      viewBox='0 0 42 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={clsx(isPressed ? 'drop-shadow-[0_0_10px_rgba(250,204,21,0.75)]' : '')}
    >
      <g filter='url(#filter0_d_308_19967)'>
        <rect
          id={prefix.concat('StickClick')}
          x='4'
          width='34'
          height='32'
          rx='16'
          fill={fillColor}
          fillOpacity='0.75'
          shapeRendering='crispEdges'
        />
        <rect
          className='pointer-events-none'
          x='5'
          y='1'
          width='32'
          height='30'
          rx='15'
          stroke='white'
          strokeOpacity='0.75'
          strokeWidth='2'
          shapeRendering='crispEdges'
        />
        <path className='pointer-events-none' d='M17.5 16L17.5 22' stroke='white' strokeOpacity='0.75' />
        <line className='pointer-events-none' x1='24.5' y1='16' x2='24.5' y2='22' stroke='white' strokeOpacity='0.75' />
        <rect className='pointer-events-none' x='14.5' y='12.5' width='13' height='3' rx='1.5' stroke='white' strokeOpacity='0.75' />
        <g clipPath='url(#clip0_308_19967)'>
          <path
            className='pointer-events-none'
            d='M21.2828 10.9031C21.1265 11.0333 20.8728 11.0333 20.7165 10.9031L19.1165 9.56979C19.0015 9.47396 18.9678 9.33125 19.0303 9.20625C19.0928 9.08125 19.2378 9 19.4003 9H22.6003C22.7615 9 22.9078 9.08125 22.9703 9.20625C23.0328 9.33125 22.9978 9.47396 22.884 9.56979L21.284 10.9031H21.2828Z'
            fill='white'
            fillOpacity='0.75'
          />
        </g>
        <path
          className='pointer-events-none'
          d={
            isLeft
              ? 'M20.0403 21.4286V17.7922H20.4807V21.038H22.171V21.4286H20.0403Z'
              : 'M20.0403 21.4286V17.7922H21.269C21.5531 17.7922 21.7863 17.8408 21.9686 17.9378C22.1509 18.0337 22.2858 18.1657 22.3734 18.3338C22.461 18.5019 22.5048 18.693 22.5048 18.9073C22.5048 19.1215 22.461 19.3115 22.3734 19.4772C22.2858 19.643 22.1515 19.7732 21.9704 19.8679C21.7893 19.9614 21.5578 20.0081 21.2761 20.0081H20.2818V19.6104H21.2619C21.456 19.6104 21.6123 19.582 21.7307 19.5252C21.8502 19.4684 21.9366 19.3879 21.9899 19.2837C22.0443 19.1784 22.0716 19.0529 22.0716 18.9073C22.0716 18.7617 22.0443 18.6344 21.9899 18.5255C21.9354 18.4166 21.8484 18.3326 21.7289 18.2734C21.6093 18.213 21.4513 18.1829 21.2548 18.1829H20.4807V21.4286H20.0403ZM21.752 19.7951L22.6469 21.4286H22.1355L21.2548 19.7951H21.752Z'
          }
          fill='white'
          fillOpacity='0.75'
        />
      </g>
      <defs>
        <filter id='filter0_d_308_19967' x='0' y='0' width='42' height='40' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_308_19967' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_308_19967' result='shape' />
        </filter>
        <clipPath id='clip0_308_19967'>
          <rect width='4' height='2' fill='white' transform='translate(19 9)' />
        </clipPath>
      </defs>
    </svg>
  );
};
